import React, { useState, useEffect } from "react";
import {
  Modal,
  Input,
  //   Select,
  Button,
  Typography,
  DatePicker,
  Loading,
} from "../../../core";
import { Form, Row, Col, Select, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

import { MixStyle } from "../../../styles";

import styled from "styled-components";
import { useForm } from "antd/lib/form/util";

import { addClothReturn } from "../../../helper/utils/api/dispatch";
const CHANGE_DATE_FORMAT = require("../../../helper/utils/datFormat");

const { Option } = Select;

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const ClothReturnModalCompo = ({
  clothReturnModal,
  dispatches,
  contractDetails,
  closeModal,
  getDispatchesOfCurrentContract,
}) => {
  let [form] = useForm();

  const [dispatchForReturn, setDispatchForReturn] = useState([]);

  useEffect(() => {
    let openDispatch = dispatches.filter(
      (dispatch) => dispatch.status === "dispatchOpen"
    );
    setDispatchForReturn(openDispatch);
  }, [dispatches]);
  const [isLoading, setIsLoading] = useState(false);
  const [clothReturn, setClothReturn] = useState({});
  const [selectedDispatch, setSelectedDispatch] = useState("");

  const onFinish = async (fieldsValue) => {
    console.log("fieldsValue", fieldsValue);
    console.log("clothReturn", clothReturn);

    const requestBody = clothReturn;
    delete requestBody.dispatch_id_cloth_return;
    console.log("clothReturn", clothReturn);

    // let companyId = localStorage.getItem("companyId");
    // let addDispatchObject = {
    //   contractId: contractDetails._id,
    //   companyId,
    //   ...fieldsValue,
    // };
    // console.log("addDispatchObject", addDispatchObject);

    let paramsObject = {
      contractId: contractDetails._id,
      dispatchId: selectedDispatch,
      clothReturnPayload: clothReturn,
    };

    await addClothReturnHandler(paramsObject);
  };

  const onValuesChange = (values, valueChanged) => {
    console.log("valueChanged", valueChanged);
    console.log("values", values);
    if (selectedDispatch && values.glrReceived) {
      // let { kachiQuantity, lShort } = selectedDispatch;

      let { kachiQuantity, lShort } = dispatches.find(
        (dispatch) => dispatch._id === selectedDispatch
      );
      let netPass =
        parseInt(kachiQuantity) -
        parseInt(lShort) -
        parseInt(values.glrReceived);

      form.setFieldsValue({
        netPass,
      });
      console.log("netPass", netPass);
    }

    setClothReturn((prev) => ({
      ...prev,
      ...valueChanged,
      status: "dispatchClosed",
    }));
  };

  const onFinishFailed = () => {};

  const addClothReturnHandler = async (payloadObject) => {
    setIsLoading(true);
    try {
      let response = await addClothReturn(payloadObject);
      console.log("response", response);
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
    closeModalHandler();
    getDispatchesOfCurrentContract();
  };

  const closeModalHandler = () => {
    closeModal("clothReturnModal");
  };

  const onSelectDispatchHandler = (diaptch) => {
    console.log("string ", diaptch);
    setSelectedDispatch(diaptch);
  };

  return (
    <Modal
      closable={true}
      visible={clothReturnModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Add Cloth Return "
    >
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col span={24}>
            <Form.Item
              label="Select Dispatch"
              name="dispatch_id_cloth_return"
              rules={[
                {
                  required: true,
                  message: "Please select Dispatch",
                },
              ]}
            >
              <Select defaultValue="" onSelect={onSelectDispatchHandler}>
                {/* <Option value="">select buyer</Option> */}
                {dispatchForReturn.map((dispatch) => (
                  <Option value={dispatch._id}>
                    <Space>
                      <span className="themed--color_pink">k.Quanity:</span>
                      {dispatch.kachiQuantity}
                      <span className="themed--color_pink">
                        Dispatch Date :
                      </span>
                      {CHANGE_DATE_FORMAT.changeDateFormat(
                        dispatch.dispatchDate
                      )}
                    </Space>
                  </Option>
                ))}
              </Select>

              {/* <Select
                placeholder="Select Dispatch"
                type="dispatches"
                Options={AllDispatches ? AllDispatches : ["Loading..."]}
              /> */}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Date"
              name="clothReturnDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="G/L/R Received"
              name="glrReceived"
              rules={[
                {
                  required: true,
                  message: "Please Enter G/L/R Received ",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Net Pass"
              name="netPass"
              rules={[
                {
                  required: true,
                  message: "Please Enter  Net Pass!",
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="P patch parchi #"
              name="packiParchiNumber"
              rules={[
                {
                  required: true,
                  message: "Please Enter  P patch parchi #!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.List name="clothReturnVariations">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    {fields.map((field, index) => (
                      <Space
                        key={field.key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "category"]}
                          fieldKey={[field.fieldKey, "category"]}
                          rules={[
                            { required: true, message: "Plz Enter category" },
                          ]}
                        >
                          <Select defaultValue="">
                            <Option value="">Select Catagory </Option>
                            <Option value="A Catagory">A Catagory</Option>
                            <Option value="B Catagory">B Catagory</Option>
                            <Option value="C Catagory">C Catagory</Option>
                          </Select>
                          {/* <Select
                            placeholder="Catagory 2"
                            Options={["A Catagory", "B Catagory", "C Catagory"]}
                          /> */}
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "quantity"]}
                          fieldKey={[field.fieldKey, "quantity"]}
                          rules={[
                            { required: true, message: "Input Quanitity" },
                          ]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder="Quanitity"
                            // prefix={<UserOutlined />}
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "rate"]}
                          fieldKey={[field.fieldKey, "rate"]}
                          rules={[{ required: true, message: "Input Rate" }]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder="Rate"
                            // prefix={<UserOutlined />}
                          />
                        </Form.Item>

                        {/* {fields.length > 1 ? ( */}
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                        {/* ) : null} */}
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        width="187px"
                        margin="auto"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                          // setVariant(true);
                        }}
                      >
                        <PlusOutlined /> Add Variation
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col xs={24} sm={24}>
            <Row type="flex" justify="center">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default ClothReturnModalCompo;
